<sms-dialog [title]="'What\'s New — Version ' + data.version" [size]="'sm'" (close)="close()">

  <div body class="wn-body">
    <p class="wn-intro">Here's what's new in this release:</p>
    <ul class="wn-list">
      <li *ngFor="let feature of data.features" class="wn-item">
        <span class="wn-icon">✨</span>
        <span>{{ feature }}</span>
      </li>
    </ul>
  </div>

  <ng-container footer>
    <button type="button" class="primary-button" (click)="close()">Got it</button>
  </ng-container>

</sms-dialog>
